import {Account} from "../../../../core/entities/account/domain/model/account.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class AccountActivatedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'AccountActivatedEvent';

  constructor(public readonly account?: Account) {
  }
}
